<template>
  <div>
    <v-dialog max-width="800" v-model="menu">
      <template v-slot:activator="{ props }">
        <v-btn
          v-if="type === 'button'"
          v-bind="props"
          elevation="0"
          color="smokeDark"
          height="44"
        >
          Add category
        </v-btn>
        <v-btn
          v-bind="props"
          icon="mdi-plus"
          variant="text"
          v-else-if="type === 'plus'"
        ></v-btn>
        <v-list-item
          v-bind="props"
          v-if="type === 'list'"
          density="compact"
          link
        >
          <v-list-item-title style="font-size: 10pt" class="d-flex align-center"
            ><v-icon size="16" class="mr-2">mdi-plus</v-icon>Start
            empty</v-list-item-title
          >
        </v-list-item>
      </template>

      <template v-slot:default>
        <v-card
          flat
          :style="{
            borderBottom: '3px solid #272727',
            borderLeft: '1px solid #272727',
            borderTop: '1px solid #272727',
            borderRight: '3px solid #272727',
            borderRadius: '10px',
          }"
          width="600"
        >
          <div class="px-6 py-6">
            <p style="font-size: 13pt; font-weight: 500">Add category</p>
            <p style="font-size: 10pt; font-weight: 400" class="mb-4">
              Create a new category to help you organize your posts.
            </p>
            <v-text-field
              placeholder="Category name"
              variant="solo"
              class="mb-2"
              flat
              label="Name"
              bg-color="smokeDark"
              hide-details=""
              v-model="new_category.name"
            ></v-text-field>

            <v-textarea
              placeholder="This category of posts is about..."
              variant="solo"
              class="mb-2"
              style="font-size: 10pt"
              flat
              label="Description"
              bg-color="smokeDark"
              hide-details=""
              rows="2"
              v-model="new_category.description"
            ></v-textarea>
            <v-combobox
              chips
              label="Keywords"
              hide-details=""
              variant="solo"
              bg-color="smokeDark"
              flat
              class="mb-2"
              multiple
              v-model="new_category.keywords"
            ></v-combobox>

            <div class="mb-2">
              <v-text-field
                label="Category goals"
                bg-color="smokeDark"
                placeholder="Inform audience about ..."
                v-model="goal"
                variant="solo"
                flat
                hide-details=""
                @keyup.enter="
                  new_category.goals.push(goal);
                  goal = '';
                "
              >
                <template v-slot:append-inner>
                  <v-btn
                    variant="text"
                    size="small"
                    icon="mdi-plus"
                    @click="
                      new_category.goals.push(goal);
                      goal = '';
                    "
                  ></v-btn>
                </template>
              </v-text-field>
              <div
                class="pa-4 d-flex flex-wrap"
                style="gap: 3px"
                v-if="new_category.goals.length > 0"
              >
                <v-chip
                  multi-line
                  size="small"
                  v-for="(g, index) in new_category.goals"
                  :key="index"
                  closable=""
                  @click:close="new_category.goals.splice(index, 1)"
                  >{{ g }}</v-chip
                >
              </div>
            </div>

            <!-- <v-btn
            v-bind:class="{ smoke: new_category.color === c }"
            icon
            variant="text"
            v-for="(c, index) in colors"
            :key="index"
            @click="new_category.color = c"
            ><v-icon :color="c">{{
              c === new_category.color ? "mdi-check-circle" : "mdi-circle"
            }}</v-icon></v-btn
          > -->
          </div>

          <v-divider></v-divider>
          <v-card-actions class="px-4">
            <v-spacer></v-spacer>
            <v-btn text @click="menu = false">Cancel</v-btn>
            <v-btn
              elevation="0"
              style="
                border-left: 1px solid #272727;
                border-right: 3px solid #272727;
                border-top: 1px solid #272727;
                border-bottom: 3px solid #272727;
                border-radius: 8px;
              "
              variant="flat"
              color="button"
              :loading="saving"
              @click="addCategory"
              :disabled="!new_category.name"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import { doc, updateDoc, getDoc, addDoc, collection } from "firebase/firestore";
import { db } from "@/firebase";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      workspace: (state) => state.workspace.workspace,
      loading: (state) => state.loading,
      structures: (state) => state.structures.structures,
      brands: (state) => state.workspace.brands,
    }),
  },
  props: ["type"],
  data() {
    return {
      colors: [
        "#67d6fa",
        "#cfb8ff",
        "#fa7a68",
        "#ffd978",
        "#c9fa75",
        "#b6b6b6",
        "#ff94d6",
        "#75f7e3",
        "#ffa574",
        "#a7f784",
      ],
      menu: false,
      new_category: {
        name: "",
        description: "",
        deletable: true,
        counter: {
          posts: 0,
        },
        email: false,
        schedules: [],
        schedule: null,
        status: "draft",
        goals: [],

        uid: null,
        keywords: [],
      },
      saving: false,
    };
  },
  methods: {
    clear() {
      this.new_category = {
        name: "",
        description: "",
        deletable: true,
        counter: {
          posts: 0,
        },
        schedules: [],
        uid: null,
        keywords: [],
        email: false,
        goals: [],
        schedule: null,
        status: "draft",
      };
    },
    async addCategory() {
      this.$store.commit("setLoading", { type: "categories", val: false });
      this.saving = true;

      if (!this.new_category.uid) {
        const docRef = await addDoc(
          collection(
            db,
            "workspaces",
            this.$store.state.users.userProfile.workspace,
            "categories"
          ),
          {
            active: false,
            ...this.new_category,
            schedule: {
              day_of_week: [Math.floor(Math.random() * 6) + 1],
              frequency: Math.floor(Math.random() * 4) + 1,
              type: "weeks",
              month_day: null,
              timeslot: "08:17",
              last_slot: null,
            },
            created_at: Math.floor(Date.now() / 1000),
          }
        );

        const updateRef = doc(
          db,
          "workspaces",
          this.$store.state.users.userProfile.workspace,
          "categories",
          docRef.id
        );

        // Set the "capital" field of the city 'DC'
        await updateDoc(updateRef, {
          uid: docRef.id,
        });

        await this.$store.dispatch("fetchCategories");
        this.clear();
        this.saving = false;
        this.menu = false;
        this.$emit("new", docRef.id);
      } else {
        const updateRef = doc(
          db,
          "workspaces",
          this.$store.state.users.userProfile.workspace,
          "categories",
          this.new_category.uid
        );

        await updateDoc(updateRef, this.new_category);
        await this.$store.dispatch("fetchCategories");
        this.saving = false;
        this.menu = false;
      }
      this.$store.commit("setLoading", { type: "categories", val: false });
    },
    async open(c) {
      console.log(c);
      const docRef = doc(
        db,
        "workspaces",
        this.$store.state.users.userProfile.workspace,
        "categories",
        c
      );
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        this.new_category = docSnap.data();
      } else {
        // docSnap.data() will be undefined in this case
        console.log("No such document!");
      }
      this.isActive.value = true;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-dialog {
  border-radius: 10px;
}
</style>
